import http from "./http";
import jsonUtil from "@/utils/jsonUtil.js";
const finance = {

  //待退款申请记录
  getList(page, size, timeRange, author, title, status,statusResult) {
    return http.post(
      "refund/refund/list?page=" + page + "&size=" + size + "&timeRange=" + timeRange + "&author=" + author + "&title=" + title + "&status=" + status +"&statusResult="+statusResult
    );
  },

  //收款记录
  getPayedList(page,size,model){
    return http.post(
      "finance/orderPay/allList?page=" + page + "&size=" + size ,model
    );
  },

  //下载收款记录
  exportXLSForPayedList(ids) {
    let modal = {
      orderPayIds: ids,
    };
    return http.post("finance/orderPay/download", modal, { responseType: 'blob' });
  },

  //审核待退款的稿件
  audit(type,ids) {
    let modal = {
      refundIds: ids,
    };
    return http.post("refund/refund/audit?type="+type, modal);
  },

  //下载待退款的稿件
  exportXLS(ids) {
    let modal = {
      refundIds: ids,
    };
    return http.post("refund/refund/download", modal, { responseType: 'blob' });
  },




  //发票列表
  getInvoiceListForPage(page,size,model) {
    return http.post(
      "invoice/invoice/getList2?page=" + page + "&size=" + size ,model
    );
  },

  //修改发票状态
  setStatus(ids,status) {
    let modal = {
      ids: Array.isArray(ids)?ids.join(','):ids,
      status:status
    };
    let query = jsonUtil.toQuery(modal);
    return http.post("invoice/invoice/setStatus", query);
  },

  //下载发票信息表
  exportXLSForInvioce(ids) {
    let modal = {
      invoiceIds: ids,
    };
    return http.post("invoice/invoice/download", modal, { responseType: 'blob' });
  },

};
export default finance;
